module.exports = "/images/checkbox-checked.3631fbb888a8bbc119de24c2627d00b0.svg";